import { render, staticRenderFns } from "./PhotosPublic.vue?vue&type=template&id=b033341e"
import script from "./PhotosPublic.vue?vue&type=script&lang=js"
export * from "./PhotosPublic.vue?vue&type=script&lang=js"
import style0 from "./PhotosPublic.vue?vue&type=style&index=0&id=b033341e&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports